/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { ScorecardFeedback } from './ScorecardFeedback.js';
import {
    ScorecardFeedbackFromJSON,
    ScorecardFeedbackFromJSONTyped,
    ScorecardFeedbackToJSON,
} from './ScorecardFeedback.js';

/**
 * 
 * @export
 * @interface GetScorecardFeedbacksResponse
 */
export interface GetScorecardFeedbacksResponse {
    /**
     * 
     * @type {Array<ScorecardFeedback>}
     * @memberof GetScorecardFeedbacksResponse
     */
    data?: Array<ScorecardFeedback>;
    /**
     * 
     * @type {number}
     * @memberof GetScorecardFeedbacksResponse
     */
    totalRecords?: number;
    /**
     * 
     * @type {number}
     * @memberof GetScorecardFeedbacksResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof GetScorecardFeedbacksResponse
     */
    pages?: number;
    /**
     * 
     * @type {Array<Error>}
     * @memberof GetScorecardFeedbacksResponse
     */
    errors?: Array<Error>;
}

/**
 * Check if a given object implements the GetScorecardFeedbacksResponse interface.
 */
export function instanceOfGetScorecardFeedbacksResponse(value: object): boolean {
    return true;
}

export function GetScorecardFeedbacksResponseFromJSON(json: any): GetScorecardFeedbacksResponse {
    return GetScorecardFeedbacksResponseFromJSONTyped(json, false);
}

export function GetScorecardFeedbacksResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetScorecardFeedbacksResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(ScorecardFeedbackFromJSON)),
        'totalRecords': json['totalRecords'] == null ? undefined : json['totalRecords'],
        'page': json['page'] == null ? undefined : json['page'],
        'pages': json['pages'] == null ? undefined : json['pages'],
        'errors': json['errors'] == null ? undefined : json['errors'],
    };
}

export function GetScorecardFeedbacksResponseToJSON(value?: GetScorecardFeedbacksResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(ScorecardFeedbackToJSON)),
        'totalRecords': value['totalRecords'],
        'page': value['page'],
        'pages': value['pages'],
        'errors': value['errors'],
    };
}

